import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './two-column-resposive-block.scss.js';

class TwoColumnResposiveBlock extends s {
    constructor() {
        super(...arguments);
        this.ctaStyleLeft = 'primary';
        this.ctaStyleRight = 'primary';
        this.ctaAlignSlotLeft = 'center';
        this.ctaAlignSlotRight = 'center';
        this.hasTextOnlyBlocksInBothColumns = false;
    }
    firstUpdated() {
        const leftSlot = this.shadowRoot.querySelector('slot[name="left"]');
        const rightSlot = this.shadowRoot.querySelector('slot[name="right"]');
        const findElementDeep = (parent, selector) => {
            if (parent instanceof HTMLElement && parent.matches(selector))
                return parent;
            if (parent instanceof HTMLElement && parent.shadowRoot) {
                const shadowMatch = parent.shadowRoot.querySelector(selector);
                if (shadowMatch)
                    return shadowMatch;
            }
            for (const child of parent.childNodes) {
                if (child instanceof HTMLElement) {
                    const found = findElementDeep(child, selector);
                    if (found)
                        return found;
                }
            }
            return null;
        };
        const observedElements = new WeakSet();
        const observedImages = new WeakSet();
        let scheduledFrame = null;
        let retryTimer = null;
        let isSyncing = false;
        let syncHeightsAndWidths;
        const runSync = () => {
            if (isSyncing)
                return;
            isSyncing = true;
            try {
                syncHeightsAndWidths();
            }
            finally {
                isSyncing = false;
            }
        };
        const scheduleSync = (withRetries = false) => {
            if (scheduledFrame !== null) {
                cancelAnimationFrame(scheduledFrame);
            }
            scheduledFrame = requestAnimationFrame(() => {
                scheduledFrame = null;
                runSync();
            });
            if (!withRetries)
                return;
            if (retryTimer !== null) {
                clearTimeout(retryTimer);
            }
            let attempts = 0;
            const runRetry = () => {
                if (attempts >= 6) {
                    retryTimer = null;
                    return;
                }
                attempts += 1;
                runSync();
                retryTimer = window.setTimeout(runRetry, 250);
            };
            retryTimer = window.setTimeout(runRetry, 250);
        };
        const registerImageLoad = (img) => {
            if (observedImages.has(img))
                return;
            observedImages.add(img);
            img.addEventListener('load', () => scheduleSync(true));
            img.addEventListener('error', () => scheduleSync());
            if (img.complete) {
                scheduleSync();
            }
        };
        const observeElementTree = (root) => {
            const elements = root instanceof Element
                ? [root, ...Array.from(root.querySelectorAll('*'))]
                : Array.from(root.querySelectorAll('*'));
            elements.forEach(element => {
                var _a;
                if (element instanceof HTMLElement && !observedElements.has(element)) {
                    observedElements.add(element);
                    (_a = this.resizeObserver) === null || _a === void 0 ? void 0 : _a.observe(element);
                }
                if (element instanceof HTMLImageElement) {
                    registerImageLoad(element);
                }
                if (element instanceof HTMLElement && element.shadowRoot) {
                    observeElementTree(element.shadowRoot);
                }
            });
        };
        const observeAssignedSlotContent = (slot) => {
            slot.assignedElements({ flatten: true }).forEach(element => {
                var _a, _b;
                (_a = this.mutationObserver) === null || _a === void 0 ? void 0 : _a.observe(element, {
                    childList: true,
                    subtree: true,
                });
                if (element.shadowRoot) {
                    (_b = this.mutationObserver) === null || _b === void 0 ? void 0 : _b.observe(element.shadowRoot, {
                        childList: true,
                        subtree: true,
                    });
                }
                observeElementTree(element);
            });
        };
        const containsTextOnlyBlock = (elements) => elements.some(element => {
            var _a, _b;
            const htmlElement = element;
            return (((_a = htmlElement.matches) === null || _a === void 0 ? void 0 : _a.call(htmlElement, 'text-only-block')) ||
                ((_b = htmlElement.querySelector) === null || _b === void 0 ? void 0 : _b.call(htmlElement, 'text-only-block')) !== null);
        });
        const updateDividerState = () => {
            const leftElements = leftSlot.assignedElements({ flatten: true });
            const rightElements = rightSlot.assignedElements({ flatten: true });
            const shouldHideDivider = containsTextOnlyBlock(leftElements) &&
                containsTextOnlyBlock(rightElements);
            if (this.hasTextOnlyBlocksInBothColumns !== shouldHideDivider) {
                this.hasTextOnlyBlocksInBothColumns = shouldHideDivider;
                this.requestUpdate();
            }
        };
        // eslint-disable-next-line sonarjs/cognitive-complexity
        syncHeightsAndWidths = () => {
            const isDesktop = window.innerWidth > 1024;
            const leftElements = leftSlot.assignedElements({ flatten: true });
            const rightElements = rightSlot.assignedElements({ flatten: true });
            const resetHeightStyles = (element) => {
                element.style.removeProperty('height');
                element.style.removeProperty('min-height');
            };
            const applyHeightStyles = (element, height) => {
                element.style.height = `${height}px`;
                element.style.minHeight = `${height}px`;
            };
            const stretchSupportedComponents = (container) => {
                TwoColumnResposiveBlock.MULTIBLOCK_SUPPORTED_COMPONENTS.forEach(selector => {
                    var _a, _b, _c, _d, _e;
                    const component = findElementDeep(container, selector);
                    if (!component)
                        return;
                    component.style.height = '100%';
                    component.style.minHeight = '100%';
                    component.style.width = '100%';
                    if (selector === 'cross-sell') {
                        const crossSellArticle = (_a = component.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('article.multicolumn-cross');
                        if (crossSellArticle) {
                            crossSellArticle.style.height = '100%';
                            crossSellArticle.style.minHeight = '100%';
                            crossSellArticle.style.marginTop = '0';
                            crossSellArticle.style.marginBottom = '0';
                        }
                    }
                    if (selector === 'image-block') {
                        const imageBlockRoot = (_b = component.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('.image-block');
                        const imageElement = component.querySelector('img');
                        imageBlockRoot === null || imageBlockRoot === void 0 ? void 0 : imageBlockRoot.style.setProperty('height', '100%');
                        imageBlockRoot === null || imageBlockRoot === void 0 ? void 0 : imageBlockRoot.style.setProperty('min-height', '100%');
                        imageBlockRoot === null || imageBlockRoot === void 0 ? void 0 : imageBlockRoot.style.setProperty('display', 'flex');
                        imageBlockRoot === null || imageBlockRoot === void 0 ? void 0 : imageBlockRoot.style.setProperty('align-items', 'stretch');
                        imageElement === null || imageElement === void 0 ? void 0 : imageElement.style.setProperty('height', '100%');
                        imageElement === null || imageElement === void 0 ? void 0 : imageElement.style.setProperty('object-fit', 'cover');
                    }
                    if (selector === 'title-link-block') {
                        const titleLinkSection = (_c = component.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('section.container');
                        if (titleLinkSection) {
                            titleLinkSection.style.height = '100%';
                            titleLinkSection.style.minHeight = '100%';
                            titleLinkSection.style.display = 'flex';
                            titleLinkSection.style.flexDirection = 'column';
                            const linkList = (_d = component.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector('.link-list');
                            linkList === null || linkList === void 0 ? void 0 : linkList.style.setProperty('flex', '1 1 auto');
                        }
                    }
                    if (selector === 'cards-gallery-plus' || selector === 'cards-gallery') {
                        const gallerySection = (_e = component.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector('section.cards-gallery-plus, section.cards-gallery');
                        gallerySection === null || gallerySection === void 0 ? void 0 : gallerySection.style.setProperty('height', '100%');
                        gallerySection === null || gallerySection === void 0 ? void 0 : gallerySection.style.setProperty('min-height', '100%');
                    }
                    if (selector === 'image-block-container') {
                        const shadow = component.shadowRoot;
                        const containerEl = shadow === null || shadow === void 0 ? void 0 : shadow.querySelector('.container');
                        const mediaWrapper = shadow === null || shadow === void 0 ? void 0 : shadow.querySelector('.media-wrapper');
                        const genericImage = shadow === null || shadow === void 0 ? void 0 : shadow.querySelector(TwoColumnResposiveBlock.GENERIC_IMAGE_SELECTOR);
                        const genericImageShadow = genericImage === null || genericImage === void 0 ? void 0 : genericImage.shadowRoot;
                        const genericImageRoot = genericImageShadow === null || genericImageShadow === void 0 ? void 0 : genericImageShadow.querySelector('div, figure');
                        const genericImageWrapper = genericImageShadow === null || genericImageShadow === void 0 ? void 0 : genericImageShadow.querySelector('.wrapper');
                        const genericImageMedia = genericImageShadow === null || genericImageShadow === void 0 ? void 0 : genericImageShadow.querySelector('img.media');
                        containerEl === null || containerEl === void 0 ? void 0 : containerEl.style.setProperty('height', '100%');
                        mediaWrapper === null || mediaWrapper === void 0 ? void 0 : mediaWrapper.style.setProperty('height', '100%');
                        mediaWrapper === null || mediaWrapper === void 0 ? void 0 : mediaWrapper.style.setProperty('max-inline-size', '100%');
                        mediaWrapper === null || mediaWrapper === void 0 ? void 0 : mediaWrapper.style.setProperty('inline-size', '100%');
                        genericImage === null || genericImage === void 0 ? void 0 : genericImage.style.setProperty('--gi-height', '100%');
                        genericImage === null || genericImage === void 0 ? void 0 : genericImage.style.setProperty('height', '100%');
                        genericImageRoot === null || genericImageRoot === void 0 ? void 0 : genericImageRoot.style.setProperty('height', '100%');
                        genericImageWrapper === null || genericImageWrapper === void 0 ? void 0 : genericImageWrapper.style.setProperty('height', '100%');
                        genericImageMedia === null || genericImageMedia === void 0 ? void 0 : genericImageMedia.style.setProperty('height', '100%');
                        genericImageMedia === null || genericImageMedia === void 0 ? void 0 : genericImageMedia.style.setProperty('object-fit', 'cover');
                    }
                });
            };
            const equalizeColumnItemsByPair = () => {
                const leftItems = leftElements.filter(element => element instanceof HTMLElement);
                const rightItems = rightElements.filter(element => element instanceof HTMLElement);
                leftItems.forEach(resetHeightStyles);
                rightItems.forEach(resetHeightStyles);
                if (!isDesktop)
                    return;
                const pairs = Math.min(leftItems.length, rightItems.length);
                for (let index = 0; index < pairs; index += 1) {
                    const leftItem = leftItems[index];
                    const rightItem = rightItems[index];
                    const maxHeight = Math.max(Math.round(leftItem.getBoundingClientRect().height), Math.round(rightItem.getBoundingClientRect().height));
                    if (maxHeight <= 0)
                        continue;
                    applyHeightStyles(leftItem, maxHeight);
                    applyHeightStyles(rightItem, maxHeight);
                    const leftChild = leftItem.firstElementChild;
                    const rightChild = rightItem.firstElementChild;
                    leftChild === null || leftChild === void 0 ? void 0 : leftChild.style.setProperty('height', '100%');
                    leftChild === null || leftChild === void 0 ? void 0 : leftChild.style.setProperty('min-height', '100%');
                    rightChild === null || rightChild === void 0 ? void 0 : rightChild.style.setProperty('height', '100%');
                    rightChild === null || rightChild === void 0 ? void 0 : rightChild.style.setProperty('min-height', '100%');
                    stretchSupportedComponents(leftItem);
                    stretchSupportedComponents(rightItem);
                }
            };
            equalizeColumnItemsByPair();
        };
        this.mutationObserver = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node instanceof Element) {
                        observeElementTree(node);
                    }
                });
            });
            scheduleSync(true);
        });
        this.resizeObserver = new ResizeObserver(() => scheduleSync());
        leftSlot.addEventListener('slotchange', () => {
            observeAssignedSlotContent(leftSlot);
            updateDividerState();
            scheduleSync(true);
        });
        rightSlot.addEventListener('slotchange', () => {
            observeAssignedSlotContent(rightSlot);
            updateDividerState();
            scheduleSync(true);
        });
        window.addEventListener('resize', () => scheduleSync());
        observeAssignedSlotContent(leftSlot);
        observeAssignedSlotContent(rightSlot);
        updateDividerState();
        scheduleSync(true);
    }
    disconnectedCallback() {
        var _a, _b;
        super.disconnectedCallback();
        (_a = this.resizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
        (_b = this.mutationObserver) === null || _b === void 0 ? void 0 : _b.disconnect();
    }
    static renderCTA(slotName, ctaTyle, ctaAlign) {
        return $ `<div class="cta-wrapper cta-${ctaTyle} align-${ctaAlign}"><slot name="${slotName}"></slot></div>`;
    }
    render() {
        const containerClasses = `container-responsive ${this.hasTextOnlyBlocksInBothColumns ? '' : 'has-divider'}`;
        return $ `<div class="${containerClasses}"><div class="column"><div class="slot-container"><slot name="left"></slot>${TwoColumnResposiveBlock.renderCTA('cta-left', this.ctaStyleLeft, this.ctaAlignSlotLeft)}</div></div><div class="column"><div class="slot-container"><slot name="right"></slot>${TwoColumnResposiveBlock.renderCTA('cta-right', this.ctaStyleRight, this.ctaAlignSlotRight)}</div></div></div>`;
    }
}
TwoColumnResposiveBlock.styles = [css_248z];
TwoColumnResposiveBlock.GENERIC_IMAGE_SELECTOR = 'generic-image';
TwoColumnResposiveBlock.MULTIBLOCK_SUPPORTED_COMPONENTS = [
    'cross-sell',
    'title-link-block',
    'image-block',
    'image-block-container',
    'video-block',
    'responsive-grid',
    'cards-gallery-plus',
    'cards-gallery',
];
__decorate([
    e({ type: String })
], TwoColumnResposiveBlock.prototype, "ctaStyleLeft", void 0);
__decorate([
    e({ type: String })
], TwoColumnResposiveBlock.prototype, "ctaStyleRight", void 0);
__decorate([
    e({ type: String })
], TwoColumnResposiveBlock.prototype, "ctaAlignSlotLeft", void 0);
__decorate([
    e({ type: String })
], TwoColumnResposiveBlock.prototype, "ctaAlignSlotRight", void 0);
customElements.define('two-column-resposive-block', TwoColumnResposiveBlock);

export { TwoColumnResposiveBlock };
